import { useEffect, useRef } from "react";
import { useUiSecurity } from "../../context/UiSecurityContext";

const SectionAccessGate = ({ sectionKey, children }) => {
  const { isProtectionEnabled, isUnlocked, requestAccess } = useUiSecurity();
  const hasRequestedRef = useRef(false);
  const unlocked = isUnlocked(sectionKey);

  useEffect(() => {
    if (!isProtectionEnabled || unlocked || hasRequestedRef.current) {
      return;
    }

    hasRequestedRef.current = true;
    requestAccess(sectionKey);
  }, [isProtectionEnabled, unlocked, requestAccess, sectionKey]);

  useEffect(() => {
    if (unlocked) {
      hasRequestedRef.current = false;
    }
  }, [unlocked]);

  if (!isProtectionEnabled || unlocked) {
    return children;
  }

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6 text-center shadow-sm dark:border-slate-700 dark:bg-slate-800">
      <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
        Section Locked
      </h2>
      <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
        Enter the security password to continue.
      </p>
    </div>
  );
};

export default SectionAccessGate;
